/**
 * Navigation desktop : six piliers stables, aucune entrée cachée.
 *
 * Remplace l'organisation précédente (5 entrées primaires + un menu
 * « Plus d'outils » repliant 9 entrées), conformément au paquet
 * « Biblio-Tech Design System » (ux/information-architecture).
 *
 * ⚠️ Les piliers du paquet listaient Calibre-Web, Synthèse multi-docs,
 * Espace spatial, Extraction couvertures, Simulateur de dialogue, Outils
 * Perplexity, Curation web et Notion Archive. Ces huit entrées ont été
 * retirées de ce dépôt AVEC leurs routes (cf. routes.jsx) parce que leurs
 * contrôles n'aboutissaient pas : les réintroduire ici créerait autant de
 * liens morts. Elles ne figurent donc pas ci-dessous. Leur code est
 * conservé ; les rétablir demande de rétablir l'entrée ET la route.
 *
 * Chaque `to` ci-dessous correspond à une route réellement déclarée.
 */
import {
  Home,
  Book,
  BookMarked,
  Upload,
  Cpu,
  Search,
  BookOpen,
  BarChart3,
  Database,
  Settings as SettingsIcon,
  Activity,
  FolderOpen,
  Library,
  MessagesSquare,
  SlidersHorizontal,
} from 'lucide-react';

export const SIDEBAR_PILLARS = [
  {
    id: 'accueil',
    label: 'Accueil',
    Icon: Home,
    items: [
      {
        to: '/dashboard',
        label: 'Tableau de bord',
        key: 'dashboard',
        Icon: Home,
        title: 'Statistiques, activité récente et raccourcis vers vos actions courantes',
      },
    ],
  },
  {
    id: 'bibliotheque',
    label: 'Bibliothèque',
    Icon: Library,
    items: [
      {
        to: '/',
        end: true,
        label: 'Ma bibliothèque',
        key: 'bibliotheque',
        Icon: Book,
        title: 'Grille de vos livres avec recherche, filtres avancés et tri',
      },
      {
        to: '/catalogue',
        label: 'Catalogue (vue paginée)',
        key: 'catalogue',
        Icon: BookMarked,
        title: 'Vue catalogue paginée style Calibre-Web : fiches détaillées, téléchargement',
      },
      {
        to: '/upload',
        label: 'Upload & Indexation',
        key: 'upload',
        Icon: Upload,
        className: 'tour-sidebar-upload tour-upload-btn',
        title: 'Importez des PDF ou EPUB et suivez leur indexation en temps réel',
      },
      {
        to: '/projects',
        label: 'Projets',
        key: 'projects',
        Icon: FolderOpen,
        title: 'Regroupez vos livres par sujet pour les retrouver plus vite',
      },
    ],
  },
  {
    id: 'lire',
    label: 'Lire',
    Icon: BookOpen,
    items: [
      {
        to: '/lecteur',
        label: 'Lecteur',
        key: 'lecteur',
        Icon: BookOpen,
        title: 'Reprendre la lecture (le livre s\'ouvre depuis votre bibliothèque)',
      },
    ],
  },
  {
    id: 'demander',
    label: 'Demander',
    Icon: MessagesSquare,
    items: [
      {
        to: '/recherche',
        label: 'Recherche',
        key: 'recherche',
        Icon: Search,
        title: 'Recherche full-text et sémantique dans tous vos livres',
      },
      {
        to: '/ia',
        label: 'IA (RAG)',
        key: 'ia',
        Icon: Cpu,
        title: 'Discutez avec vos livres via le moteur RAG',
      },
    ],
  },
  {
    id: 'analyser',
    label: 'Analyser',
    Icon: BarChart3,
    items: [
      {
        to: '/graphes',
        label: 'Graphe conceptuel',
        key: 'graphes',
        Icon: BarChart3,
        title: 'Concepts extraits de vos livres et leurs co-occurrences',
      },
    ],
  },
  {
    id: 'reglages',
    label: 'Réglages',
    Icon: SlidersHorizontal,
    items: [
      {
        to: '/parametres',
        label: 'Paramètres',
        key: 'parametres',
        Icon: SettingsIcon,
        title: 'Moteur IA, performance, sécurité et stockage : les réglages de l\'application',
      },
      {
        to: '/gestion',
        label: 'Gestion de données',
        key: 'gestion',
        Icon: Database,
        title: 'Sauvegardes, cache et dossiers surveillés : l\'entretien de vos données',
      },
      {
        to: '/systeme',
        label: 'Administration & santé',
        key: 'systeme',
        Icon: Activity,
        adminOnly: true,
        title: 'État des services, diagnostics et journaux techniques',
      },
    ],
  },
];
